import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import { SemiCircle } from "@components/background/semi_circle";
import { useThemeStore } from "@stores/theme.store";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export const FinancePage = () => {
  // const { setBottomNavigation } = useThemeStore((state) => state);

  // useEffect(() => {
  //   setBottomNavigation("home");
  // }, [setBottomNavigation]);
  return (
    <>
      <BaseLayout>
        <SemiCircle />
        <Header />
        <Outlet />
      </BaseLayout>
    </>
  );
};
